<template>
  <div>
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <header class="hc-hero-pri js-pri-hero">
          <div class="hc-hero-pri__container hc-section hc_container_mobile_np">
            <div class="hc-hero-pri__bg hc_mobilc_hidden">
              <img width="1024" height="682" :src="hero_bg" class="attachment-full size-full" alt="" decoding="async"
                loading="lazy" sizes="auto, (max-width: 1024px) 100vw, 1024px" />
            </div>
            <div class="hc-hero-pri__body">
              <AnimationTextBg divClass="hc-hero-pri" />
              <div class="hc-hero-pri__inner">
                <h1 class="hc-hero-pri__title t-disp-4">
                  <!-- 英文title -->
                  <template v-if="locale === 'en'">
                    {{ $t("home.subTitle") }} <br />
                    <em class="t-disp-1 en-title">{{ $t("home.title") }}</em>
                  </template>
                  <!-- 中文title -->
                  <template v-else>
                    <em class="t-disp-2 cn-title">{{ $t("home.title") }} </em>
                    <p class="cn-sub-title">
                      {{ $t("home.subTitle") }}
                    </p>
                  </template>
                </h1>
                <div class="hc-hero-pri__content">
                  <div class="hc-hero-pri__media js-pri-hero-media">
                    <figure :class="`hc-hero-pri__img js-pri-hero-img ${titleActive ? 'is-active' : ''}`">
                      <div class="hc-hero-pri__img-inner js-pri-hero-img-inner">
                        <img width="1024" height="1024" :src="gardner_at_hilton_china" class="attachment-full size-full"
                          alt="" />
                      </div>
                      <figcaption class="">
                        {{ $t("home.xianLocation") }}
                      </figcaption>
                      <div class="hc-hero-pri__return bg-teal">
                        <h2 class="t-disp-2">{{ $t("home.welcomeBack") }}</h2>
                        <p class="t-title-1">{{ $t("home.enjoy") }}</p>
                      </div>
                    </figure>
                  </div>
                  <div class="hc-hero-pri__copy">
                    <p class="has-lg-font-size ">
                      {{ $t("home.jobDesction1") }}
                    </p>
                    <CommonButton :clickHandle="() => { goPage('/searchJob')}" buttonType="secondary"
                      :buttonText="$t('searchjobs')" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </section>
    </section>
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <section class="hc-section bg-darkblue hc_container_mobile_np">
          <SectionTextureBg v-if="device === 'pc'" />
          <div class="hc-cntr">
            <section class="hc-3up-bucket">
              <div class="hc-3up-bucket__intro">
                <div class="hc-3up-bucket__copy bg-offwhite-100 bg_unset">
                  <h2 class="wp-block-heading has-t-disp-3-font-size white_color">
                    {{ $t("home.careerPathsTitle1") }}
                    <br>
                    {{ $t("home.careerPathsTitle2") }}
                  </h2>
                  <p class="has-lg-font-size white_color create-paths-desc">
                    {{ $t("home.careerPathsDesc") }}
                  </p>
                </div>
                <figure class="wp-block-image size-large">
                  <img :src="waldorf_astoria_shanghai_bund_china" alt="" />
                  <figcaption class="wp-element-caption">
                    {{ $t("home.careerPathsLoction") }}
                  </figcaption>
                </figure>
              </div>
              <!-- pc -->
              <div class="hc-3up-bucket__list" v-if="device === 'pc'">
                <template v-for="(item, index) in ducketCardList">
                  <BucketCardItem  :jobCategoryValue="item.jobCategoryValue" :imgUrl="item.imgUrl" :title="item.title" :desc="item.desc"
                    :btnText="item.btnText" />
                </template>
              </div>
              <!-- mobile -->
              <div class="hc-3up-bucket__list_mobile" v-else>
                <Swipe class="my-swipe" @change="onChange" :autoplay="0" :loop="false" :initial-swipe="0" :width="320"
                  :height="328" :show-indicators="false" indicator-color="#1989fa">
                  <swipe-item class="my-swipe-item" v-for="(item, index) in ducketCardList">
                    <BucketCardItem  :jobCategoryValue="item.jobCategoryValue" :imgUrl="item.imgUrl" :title="item.title" :desc="item.desc"
                      :btnText="item.btnText" />
                  </swipe-item>
                </Swipe>
                <div class="custom-indicators">
                  <div v-for="index in 3" :key="index" :class="{ active: currentIndex === index - 1 }"></div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </section>
    </section>
    <section class="hc-hero-bento hc-section hc-hero-bento-padding-top-80">
      <div class="hc-hero-bento__cntr hc-cntr">
        <div class="hc-hero-bento__left">
          <div class="hc-hero-bento__grid">
            <h1 class="wp-block-heading hc-hero-bento__header has-t-disp-3-font-size">
              {{ $t("home.joinTitle1") }}<br>{{ $t("home.joinTitle2") }}<br>{{ $t("home.joinTitle3") }}
            </h1>
            <!-- pc端 -->
            <template v-if="device === 'pc'">
              <figure class="wp-block-image size-large hc-hero-bento__left-img">
                <img height="880" width="1024" :src="img_bento" alt="" />
                <figcaption class="wp-element-caption">
                  {{ $t("home.joinImg1Location") }}
                </figcaption>
              </figure>

              <figure class="wp-block-image size-large hc-hero-bento__middle-img">
                <img :src="img_usb" alt="" />
                <figcaption class="wp-element-caption">
                  {{ $t("home.joinImg2Location") }}
                </figcaption>
              </figure>
            </template>
            <template v-else>
              <img style="height: auto;" width="100%" :src="locale === 'cn' ? join_us_cn : join_us_en" alt="" />
            </template>
          </div>
        </div>

        <div class="hc-hero-bento__right">
          <figure class="wp-block-image size-large hc-hero-bento__right-img">
            <img height="1024" width="811" :src="img_bento3" alt="" />
            <figcaption class="wp-element-caption">
              {{ $t("home.joinImg3Location") }}
            </figcaption>
          </figure>

          <p class="has-lg-font-size" style="text-align: left;">
            {{ $t("home.joinDesc") }}
          </p>
        </div>
      </div>
    </section>
    <!-- 最佳职场 -->
    <section class="hc-section bg-darkblue hc_container_mobile_np">
      <div class="hc-cntr hc_container_pc_np">
        <section class="hc-stag-list">
          <h2 class="wp-block-heading hc-stag-list__title has-t-disp-3-font-size">
            {{ $t("home.greatReasonTitleOne") }}
            <span>{{ $t("home.greatReasonTitleTwo") }}</span>
          </h2>

          <p class="hc-stag-list__content has-lg-font-size">
            {{ $t("home.greatReasonDesc") }}
          </p>
          <div class="hc-stag-list__button">
            <CommonButton :clickHandle="() => { goPage('/lifeAtHilton') }"
              :buttonType="device === 'pc' ? 'secondary' : 'primary-action'" :buttonText="$t('learnMore')" />
          </div>


          <div :class="`hc-stag-list__list ${(showStag || device === 'pc') ? 'show' : 'hidden'}`">
            <div class="hc-stag-item" v-for="stagItem in stagList">
              <div class="mobile-title">
                <figure class="wp-block-image aligncenter size-full">
                  <img :src="device === 'pc' ? stagItem.imgUrl : stagItem.imgMobile" alt="" />
                </figure>

                <h3 class="wp-block-heading has-t-disp-5-font-size">
                  {{ stagItem.title }}
                </h3>
              </div>
              <p class="has-sm-font-size mobile_desc">
                {{ stagItem.desc }}
              </p>
            </div>
          </div>
          <div class="mobile-show-icon" @click="showStag = !showStag">
            <img width="100%" :src="showStag ? mobile_hidden : mobile_show" alt="">
          </div>
        </section>
      </div>
    </section>
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <section class="hc-section bg-offwhite-200 hc_container_mobile_np">
          <div class="hc-cntr bg-white hc_container_mobile_np">
            <section class="hc-videos">
              <h2 class="wp-block-heading has-t-disp-3-font-size">
                {{ $t("home.HGRP1") }}
                <br />
                {{ $t("home.HGRP2") }}
              </h2>

              <div class="hc-videos__bottom">
                <div class="hc-videos__inf"  v-if="device === 'pc'">
                    <div class="hc-videos___left">
                      <h3 class="has-t-disp-4-font-size">{{ mgVideoList[currentMGIndex].title }}</h3>
                      <div class="video-desc">
                        {{ mgVideoList[currentMGIndex].desc }}
                      </div>
                    </div>
                    <div class="hc-video" @click="changePlayVideo(mgVideoList[currentMGIndex])">
                      <img :src="mgVideoList[currentMGIndex].imgUrl" alt="" width="100%">
                      <img class="play-icon" :src="GM_EP_Video" alt="" width="39" height="39">
                    </div>
                 
                </div>
                <Swipe v-else @change="onChangeVideo" :autoplay="0" :loop="false" :initial-swipe="0"
                  :show-indicators="false" indicator-color="#1989fa">
                  <swipe-item v-for="(item, index) in mgVideoList">
                    <div class="hc-videos__inf">
                      <div class="hc-videos___left">
                        <h3 class="has-t-disp-4-font-size">{{ mgVideoList[currentMGIndex].title }}</h3>
                        <div class="video-desc">
                          {{ mgVideoList[currentMGIndex].desc }}
                        </div>
                      </div>
                      <div class="hc-video">
                        <video ref="videoRef" width="100%" :poster="item.imgUrl" controls :src="item.videoUrl">
                          <track kind="captions" src="data:text/vtt;base64," srclang="en" label="No captions">
                        </video>
                      </div>
                    </div>
                  </swipe-item>
                </Swipe>
                <div class="hc-videos___right">
                  <div class="demo-img" @click="currentMGIndex = (currentMGIndex +1) % mgVideoList.length">
                    <img :src="mgVideoList[(currentMGIndex +1) % mgVideoList.length].imgUrl" alt="" width="100%">
                  </div>
                  <div class="hc-img-video__controls">
                    <img class="contro-item img-service" :src="right_arrow" alt="" @click="changeActiveMG('reduce')">
                    <div class="t-title-4 video-number">
                      <strong class="js-img-gal-pos">0{{ currentMGIndex +1 }} </strong>
                      &nbsp;/&nbsp; 0{{ mgVideoList.length }}
                    </div>
                    <img class="contro-item" :src="right_arrow" alt="" @click="changeActiveMG('add')">
                  </div>
                  <div class="custom-indicators">
                    <div v-for="index in mgVideoList.length" :key="index" :class="{ active: currentMGIndex === index - 1 }"></div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </section>
    </section>

    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <section class="hc-section hc_container_mobile_np">
          <div class="hc-cntr">
            <section class="hc-awards">
              <h2 class="wp-block-heading hc-awards__header has-t-disp-3-font-size">
                {{ $t("home.awardTitle1") }}
                <br>
                {{ $t("home.awardTitle2") }}
              </h2>
              <div class="hc-awards__bottom">
                <div class="hc-awards__left">
                  <figure class="wp-block-image size-large hc-awards__img award_img_mobile">
                    <img height="1024" width="861"
                      :src="device === 'pc'? china_beijing_doubletree_kitchen_staff : china_beijing_doubletree_kitchen_staff_mb"
                      alt="" />
                  </figure>
                </div>
                <div class="hc-awards__awards">
                  <div class="hc-awards__award" v-for="(item, index) in awards" :key="index">
                    <div class="hc-awards__award__top">
                      <p class="t-disp-6">{{ item.topDesc }}</p>
                      <img width="96" height="96" :src="item.imgUrl" class="attachment-full size-full" alt=""
                        decoding="async" loading="lazy" />
                    </div>
                    <h3 class="hc-awards__award__title t-disp-4">
                      {{ item.title }}
                    </h3>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </section>
    </section>
    <FooterScrolldoor></FooterScrolldoor>
    <VideoPlay :show="showVideo" :videoUrl="playVideo" :posterUrl="posterUrl" @closeVideo="closeVideoHandle">
    </VideoPlay>
  </div>
</template>

<script setup>
import hero_bg from "@/assets/image/home/hero_bg.jpg";
import img_bento from "@/assets/image/home/bento.jpg";
import img_usb from "@/assets/image/home/usb.jpg";
import img_bento3 from "@/assets/image/home/bento3.jpg";
import img_Default_234f60 from "@/assets/image/home/Default_234f60.svg";
import img_Default_cebc9d from "@/assets/image/home/Default_cebc9d.svg";
import img_Default_da52c9 from "@/assets/image/home/Default_da52c9.svg";
import img_Default_mo1 from "@/assets/image/home/10001.png";
import img_Default_mo2 from "@/assets/image/home/10002.png";
import img_Default_mo3 from "@/assets/image/home/10003.png";
import gardner_at_hilton_china from "@/assets/image/home/gardner-at-hilton-china-3.jpg";
import waldorf_astoria_shanghai_bund_china from "@/assets/image/home/waldorf-astoria-shanghai-bund-china.jpg";
import default_svg from "@/assets/image/home/Default.svg";
import default_cdf670_svg from "@/assets/image/home/Default_cdf670.svg";
import student_icon_svg from "@/assets/image/home/Student-Icon.svg";
import china_beijing_doubletree_kitchen_staff from "@/assets/image/home/china-beijing-doubletree-kitchen-staff.jpg";
import china_beijing_doubletree_kitchen_staff_mb from "@/assets/image/home/china-beijing-doubletree-kitchen-staff-mb.jpg"
import mobile_show from '@/assets/image/home/mobile-show.png'
import mobile_hidden from '@/assets/image/home/mobile-hidden.png'
import join_us_cn from '@/assets/image/home/join-us-cn.png';
import join_us_en from '@/assets/image/home/join-us-en.png';
import frame_35525 from "@/assets/image/home/Frame-35525.png";
import GM_EP1 from '@/assets/image/home/GM-EP1.jpg'
import GM_EP2 from '@/assets/image/home/GM-EP2.jpg'
import GM_EP3 from '@/assets/image/home/GM-EP3.jpg'
import GM_EP4 from '@/assets/image/home/GM-EP4.jpg'
import GM_EP5 from '@/assets/image/home/GM-EP5.jpg'
import GM_EP_Video from '@/assets/image/home/GM-EP-Video.png'

import right_arrow from '@/assets/image/benefits/right-arrow.svg'
import AnimationTextBg from "@/components/AnimationTextBg.vue";
import CommonButton from "@/components/CommonButton.vue";
import SectionTextureBg from "@/components/SectionTextureBg.vue";
import BucketCardItem from "@/components/BucketCardItem.vue";
import FooterScrolldoor from "@/components/FooterScrolldoor.vue";
import VideoPlay from "@/components/VideoPlay.vue";
const MG_VIDEO_EP1 = '/videos/MG-EP1.mp4'
const MG_VIDEO_EP2 = '/videos/MG-EP2.mp4'
const MG_VIDEO_EP3 = '/videos/MG-EP3.mp4'
const MG_VIDEO_EP4 = '/videos/MG-EP4.mp4'
const MG_VIDEO_EP5 = '/videos/MG-EP5.mp4'
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { ref, computed, inject, onActivated, onDeactivated } from "vue";
import { Swipe, SwipeItem } from "vant";
const device = inject("device");
const router = useRouter();
const { t, locale } = useI18n();

const titleActive = ref(true)

const ducketCardList = computed(() => {
  return [
    {
      imgUrl: default_svg,
      title: t("home.hotels"),
      desc: t("home.hotelsDesc"),
      btnText: t("home.hotelsButton"),
      jobCategoryValue: 5
    },
    {
      imgUrl: default_cdf670_svg,
      title: t("home.corporate"),
      desc: t("home.corporateDesc"),
      btnText: t("home.corporateButton"),
      jobCategoryValue: 4
    },
    {
      imgUrl: student_icon_svg,
      title: t("home.students"),
      desc: t("home.studentsDesc"),
      btnText: t("home.studentsButton"),
      jobCategoryValue: 6
    },
  ];
});
const stagList = computed(() => {
  return [
    {
      imgUrl: img_Default_234f60,
      imgMobile: img_Default_mo1,
      title: t("home.reasonOneTitle"),
      desc: t("home.reasonOneDesc"),
    },
    {
      imgUrl: img_Default_cebc9d,
      imgMobile: img_Default_mo2,
      title: t("home.reasonTwoTitle"),
      desc: t("home.reasonTwoDesc"),
    },
    {
      imgUrl: img_Default_da52c9,
      imgMobile: img_Default_mo3,
      title: t("home.reasonThreeTitle"),
      desc: t("home.reasonThreeDesc"),
    },
  ];
});

const currentMGIndex = ref(0)
const mgVideoList = computed(()=>{
  return [
    {
      imgUrl: GM_EP1,
      videoUrl: MG_VIDEO_EP1,
      title: t("home.mgVideoTitle1"),
      desc:  t("home.mgVideoDesc1"),
    },
    {
      imgUrl: GM_EP2,
      videoUrl: MG_VIDEO_EP2,
      title: t("home.mgVideoTitle2"),
      desc:  t("home.mgVideoDesc2"),
    },
    {
      imgUrl: GM_EP3,
      videoUrl: MG_VIDEO_EP3,
      title: t("home.mgVideoTitle3"),
      desc:  t("home.mgVideoDesc3"),
    },
    {
      imgUrl: GM_EP4,
      videoUrl: MG_VIDEO_EP4,
      title: t("home.mgVideoTitle4"),
      desc: t("home.mgVideoDesc4"),
    },
    {
      imgUrl: GM_EP5,
      videoUrl: MG_VIDEO_EP5,
      title: t("home.mgVideoTitle5"),
      desc: t("home.mgVideoDesc5"),
    },
  ]
})


onActivated(()=>{
  setTimeout(()=>{
    titleActive.value = true
  },0)
})
onDeactivated(()=>{
  titleActive.value = false
})

// 修改changeActiveMG函数
const changeActiveMG = (type) => {
  if(type === 'add'){
    currentMGIndex.value = (currentMGIndex.value + 1) % mgVideoList.value.length
  }else if(type === 'reduce'){
    currentMGIndex.value = (currentMGIndex.value - 1 + mgVideoList.value.length) % mgVideoList.value.length
  }
}

const showVideo = ref(false)
const playVideo = ref('')
const posterUrl = ref('')
const changePlayVideo = (item) => {
  showVideo.value = true
  playVideo.value = item.videoUrl
  posterUrl.value = item.imgUrl
}
const closeVideoHandle = () => {
  showVideo.value = false
  playVideo.value = null
  posterUrl.value = null
}

// 自定义轮播图指示器
const currentIndex = ref(0);
const onChange = (index) => {
  currentIndex.value = index;
};
const onChangeVideo = (index) => {
  currentMGIndex.value = index;
};
const awards = computed(() => {
  return [
    {
      topDesc: t("home.awardOneDesc"),
      imgUrl: frame_35525,
      title: t("home.awardOneTitle"),
    },
    {
      topDesc: t("home.awardTwoDesc"),
      imgUrl: frame_35525,
      title: t("home.awardTwoTitle"),
    },
  ];
});



// 手机端是否展示最佳职场信息
const showStag = ref(false)

const goPage= (path) => {
  router.push({
    path: path,
  });
};
</script>

<style lang="scss" scoped>
.cn-title {
  font-size: 3.75rem;
  line-height: 7.125rem;
  font-weight: 400;
}

.cn-sub-title {
  font-size: 1.75rem;
  line-height: 2rem;
  font-weight: 300;
}
.hc-hero-pri__return{
  .t-title-1{
    font-size: 2rem;
  }
}
.hc-hero-bento-padding-top-80{
  padding-top: 80px;
  padding-bottom: 80px;
}

.hc-hero-pri__copy{
      margin-top: 32px;
      text-align: left;
}
.hc-hero-bento__header {
  font-weight: 400;
}
.hc-hero-bento__right{
  p{
    text-align: justify;
  }
}
.hc-stag-item {
  figure {
      margin-bottom: 20px;
    }
}
.hc-stag-item p{
  padding: 0 20px
}

.hc-awards__header{
  font-weight: 400;
}
@media (min-width: 1024px) and (max-width: 1520px) {
  .hc_container_pc_np {
    padding: 0;
  }
}



@media (max-width: 767px) {
.cn-title {
    font-size: 2rem;
    line-height: 2.285rem;
    font-weight: 600;
  }
  .cn-sub-title{
    font-weight: 600;
    font-size: 1.142rem;
  }
  .hc-hero-bento-padding-top-80{
    padding: 32px 0;
  }
  .hc-hero-bento__header{
    padding: 0 20px;
    font-size: 2.2857rem;
    line-height: 2.857rem;
  }
    .hc-hero-bento__right {
      p {
        text-align: justify;
        padding: 0 20px;
      }
    }
  .en-title{
    font-size: 2.85rem;
  }
  // 手机端清除padding
  .hc_container_mobile_np {
    padding-inline: 0px !important;
  }
  .hc-hero-pri__container.hc_container_mobile_np{
    background-color: rgba(240, 233, 230, 1);
  }
  .has-t-disp-3-font-size{
    font-size: 2.285rem;
    line-height: 2.875rem;
  }
    .hc-hero-pri__return{
        .t-title-1 {
            font-size: 1.85rem;
          }

    }

    .hc-hero-pri__copy {
     
      text-align: center;
          margin-top: 20px;
          p{
            font-size: 1rem;
            margin-bottom: 24px;
            line-height: 1.572rem;
          }
    }

  .hc_mobilc_hidden {
    display: none;
  }

  // 手机端
  .white_color {
    color: #fff;
  }
  .create-paths-desc{
    font-size: 1rem;
  }
  
  .hc-3up-bucket__copy{
    padding: 32px 40px;
  }
  .bg_unset {
    background-color: unset;
  }

  // 最佳职场
  .hc-stag-list__title{
    text-align: left;
    padding: 0 20px;
  }
  .hc-stag-list__content{
    text-align: left;
    line-height: 1.572rem;
    padding: 0 20px;
  }
  .hc-stag-list__button{
    padding: 0 20px;
  }
  .hc-stag-list__list {
    transition: 3s;

    .mobile-title {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      justify-content: space-between;
     
      .wp-block-heading{
        font-size: 1.75rem;
        color: var(--hc-color--darkblue);
      }
      .wp-block-image{
        width: 40px;
        height: 40px;
        img{
          width: 100%;
        }
      }
    }

    .hc-stag-item {
      padding: 20px;

      background-color: var(--hc-color--white);
      text-align: left;
      figure{
        margin-bottom: unset;
      }
            h3{
              margin-bottom: 0;
            }

      p {
        margin-inline: unset;
        max-width: unset;
      }

      .has-t-disp-5-font-size {
        color: var(--hc-color--darkblue);
        font-weight: 600;
      }

      .mobile_desc {
        width: 100%;
        margin-top: 16px;
        color: var(--hc-color--neutral-600);
        padding: 0
      }
    }

  }

  .hc-stag-list__list.show {
    height: auto;
    opacity: 1;
    overflow: auto
  }

  .hc-stag-list__list.hidden {
    height: 0;
    opacity: 0;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    .hc-stag-list__list { 
      gap: 8px;
    }
  }

  .mobile-show-icon {
    display: block;
    width: 100%;
    margin-top: 20px;
  }
  .hc-awards{
    margin-inline: unset;
  }
    .hc-awards__header {
      padding: 0 20px;
      font-weight: 400;
    }

  // 荣誉图片
  .award_img_mobile {
    width: 100%;
    margin-left: unset;
    padding-top: 32px;
  }
  
}

@media (min-width: 767px) {
  .mobile-show-icon {
    display: none;
  }
  .hc-hero-bento__left{
    padding-top: 100px;
  }
  .hc-hero-bento__header{
   padding-bottom: 60px;
  }
}


.hc-3up-bucket__list_mobile {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-bottom: 30px;

  .my-swipe {
    .my-swipe-item {
      padding: 0 10px;
      display: flex;
    }
  }

  .custom-indicators {
    position: absolute;
    bottom: 0px;
    /* 将指示器放在轮播图下方 */
    left: 50%;
    transform: translateX(-50%);
    display: flex;

    div {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #FFF;
      margin: 0 8px;
    }

    div.active {
      background: #C028B9;
    }
  }
}
.hc-videos{
  padding: 80px 44px;
  .wp-block-heading{
    font-weight: 400;
  }
}
.hc-videos__bottom{
  display: flex;
  gap: 20px;
  .hc-videos__inf{
      display: flex;
      justify-content: space-between;
      gap: 20px;
      flex: 4;
      .hc-videos___left {
        flex: 2;
          .video-desc {
            width: 320px;
            margin-top: 24px;
            font-size: 1.25rem;
          }
        }
      .hc-video{
        flex: 3;
        cursor: pointer;
        position: relative;
        .play-icon{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
  }
  .hc-videos___right{
    flex: 1.1;
    display: flex;
        flex-direction: column;
          .demo-img {
              cursor: pointer;
            }
        .hc-img-video__controls{
          margin-top: 56px;
          display: flex;
          justify-content: center;
          align-items: center;
          .contro-item{
            cursor: pointer;
          }
          .img-service{
            transform: rotate(180deg);
          }
          .video-number{
            margin: 0 20px;
          }
        }
  }
}
.padding-bottoom-80{
  padding-bottom: 80px;
}

@media (max-width: 1200px) {
  .hc-videos {
      padding: 64px 22px
    }
  .hc-videos__bottom {
    .hc-videos__inf{
      .hc-videos___left {
        .has-t-disp-4-font-size{
          font-weight: 600;
        }
          .video-desc {
            width: unset;
          }
        }
    }
   
  }
    .padding-bottoom-80{
      padding-bottom: 64px;
    }
}
@media (max-width: 1023px) {
  .hc-videos__bottom{
    flex-direction: column;
    .hc-videos__inf{
      flex-direction: column-reverse;
    }
    .hc-videos___right{
      .demo-img{
        display: none;
        cursor: pointer;
      }
            .hc-img-video__controls{
              margin-top: unset;
            }
    }
  }
}
@media (max-width: 769px) {
  .hc-videos {
      padding: 32px 20px;
      .wp-block-heading{
        margin-bottom: 32px;
        padding: 0 20px;
      }
    }
         .hc-videos__bottom {
          .hc-videos__inf {
                gap: 16px;
              .hc-videos___left {
                .video-desc {
                  margin-top: 10px;
                }
              }
            }
           .hc-videos___right {
             .hc-img-video__controls {
               display: none;
             }
                             .custom-indicators {
                               display: flex;
                               justify-content: center;
                               div {
                                 width: 6px;
                                 height: 6px;
                                 border-radius: 50%;
                                 background: #F0E9E6;
                                 margin: 0 4px;
                               }
              
                               div.active {
                                 background: #C028B9;
                               }
                             }
           }
         }
}
</style>